import React from "react";
import { HtmlHTMLAttributes } from "react";
import { UtilityService } from "../../services/UtilityService";
import { Tooltip, Zoom } from "@mui/material";
interface IAvatarProps extends HtmlHTMLAttributes<"div"> {
    Name: string;
    PhoneNumber?: string;
    Index?: number;
    Size?: number;
    AspectRatio?: number;
    ImgSrc?: string;
    Status?: "online" | "offline";
    StatusPosition?: {
        top: any;
        right: any;
    }
    StatusBorder?:string;
}

const colors = [
    // "#0099ff", "#333399", "#6e6e16", "#1ac6ff", "#ff3300", "#993366", "#1a66ff", "#732673", "#75a3a3", "#003d99", "#00bfff",
    // "#26734d", "#4040bf", "#0040ff", "#0080ff", "#3333cc", "#538cc6", "#11697e", "#005ce6", "#990066", "#339900", "#990073",
    // "#1a8cff", "#24743e", "#e34b11", "#269900", "#6600ff", "#ff1a1a", "#ff0055", "#1a1aff", "#1a53ff", "#0059b3", "#3bb300",
    // "#751aff", "#3f700e", "#0d8787", "#ff8c1a", "#a3a375", "#256a53", "#5353c6", "#1d8f78", "#277842", "#e6ac00",
    // "#d11aff", "#0073e6", "#567a62", "#7300e6", "#e60073", "#ff6600", "#e68a00", "#ff0000", "#00cc66", "#009973", "#5900b3",
    // "#77b300", "#cc0099", "#669999", "#007399", "#0077b3", "#b82e8a", "#3973ac", "#739900", "#b33c00", "#cc00cc", "#00b38f",
    // "#007a99", "#0055ff", "#b30077", "#ff8000", "#ffcc00", "#330099", "#aa00ff", "#996600", "#009999", "#5c00e6",
    // "#9900ff", "#b800e6", "#0000cc", "#cc0000", "#8a8a5c", "#cc5200", "#2e5cb8", "#00cc44", "#53c68c", "#004d99",
    // "#996633", "#862d2d", "#b30047", "#993399", "#33cccc", "#00b377", "#0033cc", "#24248f", "#e6004c", "#737373", "#b30059",
    // "#cc9900", "#a31aff", "#c65353", "#661aff", "#c61aff", "#1ab2ff", "#b31aff", "#2d2d86", "#00b36b", "#2eb82e", "#a3297a",
    // "#862d59", "#c6538c", "#ff1a66", "#ff661a", "#ff1a75", "#ff1aff", "#d147a3", "#0052cc", "#b32d00", "#669900",
    // "#b36b00", "#734d26", "#990099", "#595959", "#e62e00", "#00994d", "#00e600", "#002699", "#336699", "#29a3a3", "#339933",
    // "#00e64d", "#2eb8b8", "#cc7a00", "#002db3", "#00b359", "#cc0066", "#b300b3", "#6600cc", "#86592d", "#0066cc", "#666666",
    // "#1f1f7a", "#0000ff", "#862d86", "#aaaa55", "#732626", "#bf00ff", "#99003d", "#1affc6", "#009966", "#004de6",
    // "#00997a", "#999966", "#cc00ff", "#66ff1a", "#b30086", "#0000e6", "#006699", "#e60000", "#993300", "#e65c00",
    // "#b38600", "#992600", "#73264d", "#0047b3", "#3366cc", "#00995c", "#399381", "#262673", "#ff5500", "#29a329", "#00aaff",
    // "#ff1ac6", "#40bf80", "#8a00e6", "#2952a3", "#5b8102", "#a70b93", "#7a7a52", "#00ace6", "#a300cc", "#008ae6", "#0b743a",
    // "#e67300", "#cc0044", "#5200cc", "#cc2900", "#00cc00", "#2ba589", "#2d5986", "#9900e6", "#2d862d", "#e6b800", "#8f246b",
    // "#ffaa00", "#99994d", "#41681a", "#ac00e6", "#2f957b", "#5c8a8a", "#0044cc", "#ff1ab3", "#cc6600", "#5500ff", "#cca300",
    // "#8800cc", "#00b300", "#b32400", "#264d73", "#267326", "#b3003b", "#7a1f5c", "#4700b3", "#997300", "#39e600", "#248f24",
    // "#0000b3", "#4d0099", "#4080bf", "#99004d", "#995c00", "#00b33c", "#248f8f", "#b34700", "#1aa3ff", "#b30000", "#00ffff",
    // "#888844", "#7700b3", "#b38f00", "#33cc00", "#3d0099", "#b35900", "#990033", "#003cb3", "#ffd11a", "#9900cc", "#ff471a",
    // "#8000ff", "#e600e6", "#0039e6", "#ac7339", "#2929a3", "#47d1d1", "#00cc88", "#ff9900", "#cc0052", "#ff0080", "#993333",
    // "#ff531a", "#c653c6", "#bf4040", "#e69900", "#4c00e6", "#ff0066", "#ff00aa", "#00ffaa", "#527a7a", "#4d4d4d", "#66cc00",
    // "#c68c53", "#99e600", "#1a75ff", "#00e6b8", "#e64d00", "#ff4000", "#0099e6", "#bf4080", "#ff00bf", "#1f7a1f", "#007acc",
    // "#0099cc", "#b3b300", "#24478f", "#6b6b47", "#8f00b3", "#39ac73", "#44cc00", "#7a00cc", "#000099", "#99cc00", "#990000",
    // "#ac39ac", "#cc0088", "#3b00b3", "#3d5c5c", "#4d9900", "#b37700", "#666633", "#00b3b3", "#730099", "#008fb3", "#b2b266",
    // "#00e699", "#00cccc", "#00a3cc", "#cc8800", "#4400cc", "#bf40bf", "#e60099", "#ac3939", "#476b6b", "#e6005c", "#59b300",
    // "#77773c", "#997a00", "#994d00", "#660099", "#00b386", "#003399", "#ff1a8c", "#00cc99", "#ffa31a", "#8600b3", "#008000",
    // "#993d00", "#1f7a7a", "#ffc61a", "#00ff80", "#ff00ff", "#ffb31a", "#bf8040", "#2db300", "#8c8c8c", "#009933", "#2e2eb8",
    // "#cc4400", "#86b300", "#0086b3", "#6b00b3", "#339966", "#006bb3", "#1f3d7a", "#e600ac", "#999900", "#0088cc", "#5c5c3d",
    // "#40bf40", "#00e68a", "#3939ac", "#ac3973", "#e63900", "#47d147", "#0066ff", "#ffbf00", "#88cc00", "#cc3399", "#00cca3",


    // "#E6BA95", "#9AD0EC", "#D77FA1", "#94B3FD", "#B983FF", "#6D8B74", "#F4BFBF", "#C2DED1", "#CDC2AE", "#9A86A4",
    // "#EFEAD8", "#F1F0C0", "#F9CEEE", "#CCF3EE", "#97C4B8", "#99C4C8", "#EEE4AB", "#DAE5D0", "#AC7D88", "#DEB6AB",
    // "#F8ECD1", "#8FBDD3", "#B7CADB", "#E4E9BE", "#FFF89A", "#FFB2A6", "#FF8AAE", "#9ADCFF", "#D18CE0", "#ECA6A6",
    // "#E2DEA9", "#EEEEEE", "#FFFBE9", "#E5E3C9", "#B4CFB0", "#789395", "#7882A4", "#C0A080", "#D1D1D1", "#EFEFEF",
    // "#7897AB", "#D885A3", "#FDCEB9", "#54BAB9", "#E8ECF1", "#C3DBD9", "#C8F2EF", "#A267AC", "#CE7BB0", "#FFBCD1",
    // "#6867AC", "#DACC96", "#BF8B67", "#9F71DB", "#F3C5C5", "#C1A3A3", "#D77FA1", "#E3BEC6", "#EEC373", "#DE5B7B",
    // "#BAABDA", "#E7FBBE", "#FFCBCB", "#FFFDDE", "#D3DEDC", "#7C99AC", "#A68DAD", "#D3E4CD", "#E6BA95", "#E6BA95",
    // "#FF87CA", "#FFC4E1", "#EAEAEA", "#EED7CE", "#99E1E5", "#F5B17B", "#F5EEE6", "#98DED3", "#A7D7C5", "#C8D9EB",
    // "#ECE493", "#84A1BE", "#D7EAEA", "#78B0A0", "#F29191", "#E4BAD4", "#CDC9C3", "#5AA469", "#D35D6E", "#C0BDCD",
    // "#EAB0D9", "#A7E9AF", "#6A8CAF", "#7ECFC0", "#F0F696", "#9EA9F0", "#CCC1FF", "#FFEAFE", "#FAA9E0", "#50C9BA",
    // "#B9C0D5", "#74BEC1", "#ADEBBE", "#EEF3AD", "#9AB5C1", "#DCEDC1", "#CCC1FF", "#E0F9B5", "#A5DEE5", "#50C9BA",

    // "#7C83FD", "#FD79A8", "#4B8673", "#61B15A", "#EC994B", "#646FD4", "#FF9DE2", "#FFD24C", "#4E709D", "#FF7675",
    // "#0984E3", "#E84393", "#00B894", "#2D3436", "#FDCB6E", "#6C5CE7", "#9772FB", "#E17055", "#636E72", "#D63031",
    // "#553C8B", "#CAD315", "#F57170", "#0779E4", "#7D1E6A", "#827397", "#AD8B73", "#7EB5A6", "#6E3CBC", "#FFA45B",
    // "#5E6073", "#3FC1C9", "#2F8F9D", "#7882A4", "#99A799", "#892CDC", "#694E4E", "#726A95", "#4B5D67", "#54BAB9",
    // "#EC255A", "#385170", "#FFAA64", "#27AA80", "#D96098", "#F05A28", "#F7931E", "#8D8DAA", "#C7004C", "#590696",
    // "#E97A7A", "#5357A6", "#516091", "#6C737E", "#54878F", "#29C6CD", "#CB8589", "#B36458", "#BB5A5A", "#353E55",
    // "#C84361", "#9D8F8F", "#A2738C", "#625757", "#FF7777", "#535962", "#587850", "#645C84", "#84A1BE", "#A6AA9C",
    // "#4A503D", "#CDC733", "#C67ACE", "#FF75A0", "#29BB89", "#E36387", "#71A95A", "#F05945", "#FED049",
    // "#EF7079", "#B15858", "#D69830", "#C9753D", "#D630CB", "#6B4F4F", "#6D70C6", "#D4BE6E",
    // "#809A6F", "#A3A847", "#8CC0DE", "#FF616D", "#705772", "#34D470", "#D8B384", "#FF865E", "#4C4C6D", "#E3B982",
    "#FFE4E9", "#F2EAD6", "#D3F1EC", "#F6E2FF", "#E2EBFF"
]

const textcolors = [
    "#B14056", "#9F823D", "#2B8A7B", "#6D3D82", "#41588D"
]

const defaultProps = {
    Name: "U K",
    Size: 40,
    AspectRatio: 2.5
}

const Avatar: React.FunctionComponent<IAvatarProps> = (props: IAvatarProps) => {

    let nameParts = props.Name.toUpperCase().split(" ");

    let initials = UtilityService.getInitials(nameParts[0], nameParts[1]).replace(/ /g, "");

    let hashIndex = UtilityService.getHashIndex(props.PhoneNumber ? props.PhoneNumber : props.Name.toUpperCase(), colors.length);
    // let backgroundColor = props.ImgSrc ? "#ffffff00" : colors[props.Index ? (props.Index + hashIndex) % colors.length : hashIndex];
    let backgroundColor = props.Index !== undefined ? colors[props.Index < colors.length ? props.Index : props.Index % colors.length] : colors[hashIndex]

    let style = {
        backgroundColor: !!props.ImgSrc ? "#fff" : backgroundColor,
        fontSize: (props.Size || defaultProps.Size) / (props.AspectRatio || defaultProps.AspectRatio),
        width: props.Size || defaultProps.Size,
        height: props.Size || defaultProps.Size,
        color: props.Index !== undefined ? textcolors[props.Index < textcolors.length ? props.Index : props.Index % textcolors.length] : textcolors[hashIndex]
    };
    return <div className={`avatar ${props.className || ""} ${!!props.Status ? "p-relative" : ""}`} style={style}>
        {
            props.ImgSrc ?
                <img width={props.Size || defaultProps.Size} height={props.Size || defaultProps.Size} style={{ borderRadius: "100%", maxWidth: "100%" }} src={props.ImgSrc} alt="Avatar" />
                :
                <span className="m-auto">{initials}</span>
        }
        {!!props.Status &&
            <div className={` p-absolute br-p-50 ${props.Status === "online" ? "bg-color-primary-success" : "bg-color-primary-danger"}`} style={{ width: "8px", height: "8px", top: `${props.StatusPosition?.top || "1px"}`, right: `${props.StatusPosition?.right || "1px"}`,border:props.StatusBorder || "1px solid #fff" }}>
                <Tooltip title={props.Status} placement="bottom" TransitionComponent={Zoom}>
                    <div className="">
                    </div>
                </Tooltip>
            </div>
        }
    </div>
}

Avatar.defaultProps = defaultProps;

export default Avatar;